import { hardNavigate, isMedian } from './median';
import {
  getMedianInternalExternalRules,
  getMedianLocalizationFromHostname,
  getMedianLocalizationLink,
  getMedianNavigationLevelsData,
  normalizeMedianLocalization,
} from './medianBridgeConfig';

let medianBridgeReadyPromise = null;
let appResumedListenerRegistered = false;

const MEDIAN_TAB_LABELS = {
  fr: ['Rechercher', 'Publier', 'Reservations', 'Messages', 'Compte'],
  es: ['Buscar', 'Publicar', 'Reservas', 'Mensajes', 'Cuenta'],
};

const MEDIAN_DEFAULT_NAVIGATION_TITLE = 'Swimmy';

const MEDIAN_BACK_FRIENDLY_NAVIGATION_TITLES = {
  fr: 'Retour',
  es: 'Atras',
};

const MEDIAN_NAVIGATION_TITLE_ROUTES = [
  {
    pathPattern: '/faq',
    labels: { fr: 'FAQ', es: 'FAQ' },
  },
  {
    pathPattern: '/press',
    labels: { fr: 'Presse', es: 'Prensa' },
  },
  {
    pathPattern: '/s',
    labels: { fr: 'Rechercher', es: 'Buscar' },
  },
  {
    pathPattern: '/s/filters',
    labels: { fr: 'Filtres', es: 'Filtros' },
  },
  {
    pathPattern: '/s/listings',
    labels: { fr: 'Resultats', es: 'Resultados' },
  },
  {
    pathPattern: '/s/map',
    labels: { fr: 'Carte', es: 'Mapa' },
  },
  {
    pathPattern: '/congratulation-after-ad-creation',
    labels: { fr: 'Annonce publiee', es: 'Anuncio publicado' },
  },
  {
    pathPattern: '/congratulation-after-booking',
    labels: { fr: 'Reservation confirmee', es: 'Reserva confirmada' },
  },
  {
    pathPattern: '/congratulation-after-multi-booking',
    labels: { fr: 'Reservations confirmees', es: 'Reservas confirmadas' },
  },
  {
    pathPattern: '/enquiry/:id/congrats',
    labels: { fr: 'Demande envoyee', es: 'Solicitud enviada' },
  },
  {
    pathPattern: '/proposal/:id/congrats',
    labels: { fr: 'Proposition envoyee', es: 'Propuesta enviada' },
  },
  {
    pathPattern: '/l',
    labels: { fr: 'Annonce', es: 'Anuncio' },
  },
  {
    pathPattern: '/l/new',
    labels: { fr: 'Publier', es: 'Publicar' },
  },
  {
    pathPattern: '/l/:slug/:id/checkout/proposal',
    labels: { fr: 'Proposition de prix', es: 'Propuesta de precio' },
  },
  {
    pathPattern: '/l/:slug/:id/checkout/extra',
    labels: { fr: 'Options supplementaires', es: 'Extras' },
  },
  {
    pathPattern: '/l/:slug/:id/checkout',
    labels: { fr: 'Reservation', es: 'Reserva' },
  },
  {
    pathPattern: '/l/:slug/:id/contact',
    labels: { fr: 'Contacter le proprietaire', es: 'Contactar al anfitrion' },
  },
  {
    pathPattern: '/l/:slug/:id/:type/:tab',
    labels: { fr: "Modifier l'annonce", es: 'Editar anuncio' },
  },
  {
    pathPattern: '/l/:slug/:id/:variant',
    labels: { fr: 'Annonce', es: 'Anuncio' },
  },
  {
    pathPattern: '/l/:slug/:id',
    labels: { fr: 'Annonce', es: 'Anuncio' },
  },
  {
    pathPattern: '/l/:id',
    labels: { fr: 'Annonce', es: 'Anuncio' },
  },
  {
    pathPattern: '/u',
    labels: { fr: 'Profil', es: 'Perfil' },
  },
  {
    pathPattern: '/u/:id',
    labels: { fr: 'Profil', es: 'Perfil' },
  },
  {
    pathPattern: '/login',
    labels: { fr: 'Connexion', es: 'Iniciar sesion' },
  },
  {
    pathPattern: '/signup',
    labels: { fr: 'Inscription', es: 'Registrarse' },
  },
  {
    pathPattern: '/recover-password',
    labels: { fr: 'Mot de passe oublie', es: 'Recuperar contrasena' },
  },
  {
    pathPattern: '/simulator',
    labels: { fr: 'Simulateur', es: 'Simulador' },
  },
  {
    pathPattern: '/simulator/standalone',
    labels: { fr: 'Simulateur', es: 'Simulador' },
  },
  {
    pathPattern: '/messages/:id?',
    labels: { fr: 'Messages', es: 'Mensajes' },
  },
  {
    pathPattern: '/order/:id/details',
    labels: { fr: 'Detail commande', es: 'Detalle pedido' },
  },
  {
    pathPattern: '/order/:id',
    labels: { fr: 'Commande', es: 'Pedido' },
  },
  {
    pathPattern: '/sale/:id/details',
    labels: { fr: 'Detail vente', es: 'Detalle venta' },
  },
  {
    pathPattern: '/sale/:id',
    labels: { fr: 'Vente', es: 'Venta' },
  },
  {
    pathPattern: '/listings',
    labels: { fr: 'Mes annonces', es: 'Mis anuncios' },
  },
  {
    pathPattern: '/favorites',
    labels: { fr: 'Favoris', es: 'Favoritos' },
  },
  {
    pathPattern: '/cart/checkout',
    labels: { fr: 'Paiement', es: 'Pago' },
  },
  {
    pathPattern: '/cart',
    labels: { fr: 'Panier', es: 'Carrito' },
  },
  {
    pathPattern: '/account-settings/security/change-password',
    labels: { fr: 'Changer mot de passe', es: 'Cambiar contrasena' },
  },
  {
    pathPattern: '/account-settings/security',
    labels: { fr: 'Securite', es: 'Seguridad' },
  },
  {
    pathPattern: '/account-settings/profile',
    labels: { fr: 'Mon profil', es: 'Mi perfil' },
  },
  {
    pathPattern: '/account-settings/personal-infos',
    labels: { fr: 'Infos personnelles', es: 'Informacion personal' },
  },
  {
    pathPattern: '/account-settings/payments/payment-methods',
    labels: { fr: 'Moyens de paiement', es: 'Metodos de pago' },
  },
  {
    pathPattern: '/account-settings/payments/payout-details',
    labels: { fr: 'Coordonnees bancaires', es: 'Datos bancarios' },
  },
  {
    pathPattern: '/account-settings/payments',
    labels: { fr: 'Paiements', es: 'Pagos' },
  },
  {
    pathPattern: '/account-settings/privacy',
    labels: { fr: 'Vie privee', es: 'Privacidad' },
  },
  {
    pathPattern: '/account-settings',
    labels: { fr: 'Mon compte', es: 'Mi cuenta' },
  },
  {
    pathPattern: '/income',
    labels: { fr: 'Revenus', es: 'Ingresos' },
  },
  {
    pathPattern: '/security-rules',
    labels: { fr: 'Regles de securite', es: 'Reglas de seguridad' },
  },
  {
    pathPattern: '/styleguide/c/:component/:example/raw',
    labels: { fr: 'Styleguide', es: 'Guia de estilo' },
  },
  {
    pathPattern: '/styleguide/c/:component/:example',
    labels: { fr: 'Styleguide', es: 'Guia de estilo' },
  },
  {
    pathPattern: '/styleguide/c/:component',
    labels: { fr: 'Styleguide', es: 'Guia de estilo' },
  },
  {
    pathPattern: '/styleguide/g/:group',
    labels: { fr: 'Styleguide', es: 'Guia de estilo' },
  },
  {
    pathPattern: '/styleguide',
    labels: { fr: 'Styleguide', es: 'Guia de estilo' },
  },
  {
    pathPattern: '/notfound',
    labels: { fr: 'Page introuvable', es: 'Pagina no encontrada' },
  },
  {
    pathPattern: '/who-we-are',
    labels: { fr: 'Qui sommes-nous', es: 'Quienes somos' },
  },
  {
    pathPattern: '/how-it-works',
    labels: { fr: 'Comment ca marche', es: 'Como funciona' },
  },
  {
    pathPattern: '/amateurs-de-baignade',
    labels: { fr: 'Blog baignade', es: 'Blog natacion' },
  },
  {
    pathPattern: '/amateurs-de-baignade/:slug',
    labels: { fr: 'Article baignade', es: 'Articulo natacion' },
  },
  {
    pathPattern: '/entretien-piscine',
    labels: { fr: 'Blog entretien piscine', es: 'Blog mantenimiento piscina' },
  },
  {
    pathPattern: '/entretien-piscine/:slug',
    labels: { fr: 'Article entretien piscine', es: 'Articulo mantenimiento piscina' },
  },
  {
    pathPattern: '/locations',
    labels: { fr: 'Lieux', es: 'Ubicaciones' },
  },
  {
    pathPattern: '/locations/:slug',
    labels: { fr: 'Lieu', es: 'Ubicacion' },
  },
  {
    pathPattern: '/insurance',
    labels: { fr: 'Assurance', es: 'Seguro' },
  },
  {
    pathPattern: '/legal-notice',
    labels: { fr: 'Mentions legales', es: 'Aviso legal' },
  },
  {
    pathPattern: '/terms-of-use',
    labels: { fr: "Conditions d'utilisation", es: 'Terminos de uso' },
  },
  {
    pathPattern: '/privacy-policy',
    labels: { fr: 'Politique de confidentialite', es: 'Politica de privacidad' },
  },
  {
    pathPattern: '/reset-password',
    labels: { fr: 'Reinitialiser mot de passe', es: 'Restablecer contrasena' },
  },
  {
    pathPattern: '/verify-email',
    labels: { fr: 'Verification email', es: 'Verificar correo' },
  },
  {
    pathPattern: '/your-availabilities',
    labels: { fr: 'Vos disponibilites', es: 'Disponibilidad' },
  },
  {
    pathPattern: '/reservations/:tab',
    labels: { fr: 'Reservations', es: 'Reservas' },
  },
  {
    pathPattern: '/reservations',
    labels: { fr: 'Reservations', es: 'Reservas' },
  },
  {
    pathPattern: '/calendar/:id',
    labels: { fr: 'Calendrier', es: 'Calendario' },
  },
];

const getGlobalMedianBridge = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  const Median = window.Median;

  if (!Median || !Median.internalExternal || !Median.window) {
    return null;
  }

  return Median;
};

const waitForGlobalMedianBridge = () => {
  const Median = getGlobalMedianBridge();

  if (Median) {
    return Promise.resolve(Median);
  }

  if (typeof window === 'undefined') {
    return Promise.resolve(null);
  }

  return new Promise((resolve) => {
    let count = 0;

    const interval = window.setInterval(() => {
      count += 1;

      const currentMedianBridge = getGlobalMedianBridge();
      if (currentMedianBridge || count >= 20) {
        window.clearInterval(interval);
        resolve(currentMedianBridge);
      }
    }, 500);
  });
};

const hasNativeBridge = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return !!window?.webkit?.messageHandlers?.JSBridge || !!window?.JSBridge;
};

const waitForNativeBridge = () => {
  if (typeof window === 'undefined') {
    return Promise.resolve(false);
  }

  if (!isMedian()) {
    return Promise.resolve(false);
  }

  if (hasNativeBridge()) {
    return Promise.resolve(true);
  }

  return new Promise((resolve) => {
    let count = 0;

    const interval = window.setInterval(() => {
      count += 1;

      if (hasNativeBridge() || count >= 20) {
        window.clearInterval(interval);
        resolve(hasNativeBridge());
      }
    }, 500);
  });
};

const getMedianBridge = async () => {
  const nativeBridgeAvailable = await waitForNativeBridge();

  if (!nativeBridgeAvailable) {
    return null;
  }

  return waitForGlobalMedianBridge();
};

const waitForMedianBridgeReady = async () => {
  const Median = await getMedianBridge();

  if (!Median) {
    return null;
  }

  if (!medianBridgeReadyPromise) {
    medianBridgeReadyPromise = new Promise((resolve) => {
      let resolved = false;

      const resolveBridge = () => {
        if (resolved) {
          return;
        }

        resolved = true;
        resolve(Median);
      };

      if (typeof Median.onReady === 'function') {
        Median.onReady(resolveBridge);
        window.setTimeout(resolveBridge, 1000);
      } else {
        resolveBridge();
      }
    });
  }

  return medianBridgeReadyPromise;
};

const resolveLocalization = (localization) => {
  if (localization) {
    return normalizeMedianLocalization(localization);
  }

  if (typeof window !== 'undefined') {
    return getMedianLocalizationFromHostname(window.location.hostname);
  }

  return normalizeMedianLocalization();
};

const normalizeAutomaticLocalization = (localization) => {
  const normalizedLocalization = normalizeMedianLocalization(localization);

  return normalizedLocalization === 'es' ? 'es' : 'fr';
};

const getLocalizationFromNavigator = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.navigator.languages?.[0] || window.navigator.language;
};

const getAutomaticMedianLocalization = async (localization) => {
  if (localization) {
    return normalizeAutomaticLocalization(localization);
  }

  const Median = await waitForMedianBridgeReady();

  if (typeof Median?.deviceInfo === 'function') {
    try {
      const deviceInfo = await Median.deviceInfo();

      if (deviceInfo?.language) {
        return normalizeAutomaticLocalization(deviceInfo.language);
      }
    } catch (error) {
      // Ignore and fallback to navigator/hostname detection.
    }
  }

  const navigatorLanguage = getLocalizationFromNavigator();
  if (navigatorLanguage) {
    return normalizeAutomaticLocalization(navigatorLanguage);
  }

  return normalizeAutomaticLocalization(
    getMedianLocalizationFromHostname(window.location.hostname)
  );
};

const buildLocationPath = ({ pathname = '/', search = '', hash = '' }) => {
  const normalizedPathname = pathname.startsWith('/') ? pathname : `/${pathname}`;

  return `${normalizedPathname}${search}${hash}`;
};

const resolveLocation = (location = {}) => {
  if (typeof window === 'undefined') {
    return {
      pathname: location.pathname || '/',
      search: location.search || '',
      hash: location.hash || '',
    };
  }

  return {
    pathname: location.pathname || window.location.pathname,
    search: location.search || window.location.search,
    hash: location.hash || window.location.hash,
  };
};

const buildLocationUrl = (location) => {
  if (typeof window === 'undefined') {
    return buildLocationPath(location);
  }

  return `${window.location.origin}${buildLocationPath(location)}`;
};

const getRegexMatchForUrl = (url, levels = []) => {
  return levels.find(({ regex }) => {
    try {
      return new RegExp(regex).test(url);
    } catch (error) {
      return false;
    }
  });
};

const serializeError = (error) => {
  return error instanceof Error ? error.message : String(error);
};

export const setMedianCurrentNavigationLevel = async () => {
  const navigationLevelsData = getMedianNavigationLevelsData(
    typeof window !== 'undefined' ? window.location.hostname : null
  );
  const Median = await waitForMedianBridgeReady();

  if (!Median || !Median.navigationLevels) {
    return false;
  }

  if (typeof Median.navigationLevels.setCurrent === 'function') {
    Median.navigationLevels.setCurrent({ persist: false, data: navigationLevelsData });
    return true;
  }

  if (typeof Median.navigationLevels.set === 'function') {
    Median.navigationLevels.set({ ...navigationLevelsData, persist: false });
    return true;
  }

  return false;
};

const applyMedianInternalExternalRules = async (localization) => {
  const Median = await waitForMedianBridgeReady();

  if (!Median) {
    return false;
  }

  const rules = getMedianInternalExternalRules(resolveLocalization(localization));
  Median.internalExternal.set({ rules });

  return true;
};

const registerMedianAppResumedListener = async (localizationResolver) => {
  if (appResumedListenerRegistered || typeof window === 'undefined') {
    return;
  }

  const nativeBridgeAvailable = await waitForNativeBridge();

  if (!nativeBridgeAvailable) {
    return;
  }

  const currentHandler = window.median_app_resumed;

  window.median_app_resumed = async () => {
    if (typeof currentHandler === 'function') {
      currentHandler();
    }

    const localization = localizationResolver();

    try {
      await applyMedianInternalExternalRules(localization);
      await setMedianCurrentNavigationLevel();
      await setMedianTabsForLocalization(localization);
    } catch {
      // Ignore resume update failures to avoid breaking native resume flow.
    }
  };

  appResumedListenerRegistered = true;
};

export const setupMedianBridge = async (localization) => {
  const detectedLocalization = await getAutomaticMedianLocalization(localization);
  const localizationResolver = () => detectedLocalization;

  const rulesApplied = await applyMedianInternalExternalRules(localizationResolver());

  await setMedianCurrentNavigationLevel();
  await setMedianTabsForLocalization(localizationResolver());

  await registerMedianAppResumedListener(localizationResolver);

  return rulesApplied;
};

const buildLocalizationUrl = (localization, location = {}) => {
  const baseUrl = getMedianLocalizationLink(resolveLocalization(localization));
  const locationPath = buildLocationPath(location);

  return `${baseUrl}${locationPath}`;
};

export const navigateToLocalization = async ({
  localization,
  pathname,
  search,
  hash,
  mode = 'internal',
}) => {
  const targetUrl = buildLocalizationUrl(localization, { pathname, search, hash });

  const Median = await waitForMedianBridgeReady();

  if (Median) {
    await setMedianTabsForLocalization(localization);
    Median.window.open(targetUrl, mode);
    return true;
  }

  hardNavigate(targetUrl);
  return false;
};

const joinBaseAndPath = (baseUrl, pathname) => {
  const normalizedBase = baseUrl.replace(/\/$/, '');
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${normalizedBase}${normalizedPath}`;
};

const escapeRegex = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const pathPatternToRegex = (pathPattern) => {
  if (!pathPattern || pathPattern === '/') {
    return '^https?://[^/]+/(?:[?#].*)?$';
  }

  const segments = pathPattern.split('/').filter(Boolean);

  const regexPath = segments.reduce((result, segment) => {
    if (!segment.startsWith(':')) {
      return `${result}/${escapeRegex(segment)}`;
    }

    const isOptional = segment.endsWith('?');
    return isOptional ? `${result}(?:/[^/?#]+)?` : `${result}/[^/?#]+`;
  }, '');

  return `^https?://[^/]+${regexPath}/?(?:[?#].*)?$`;
};

const getMedianNavigationTitleItems = (localization) => {
  const normalizedLocalization = normalizeAutomaticLocalization(localization);

  return MEDIAN_NAVIGATION_TITLE_ROUTES.map(({ pathPattern, labels }) => ({
    regex: pathPatternToRegex(pathPattern),
    title: labels[normalizedLocalization] || labels.fr,
  }));
};

const getMedianNavigationTitleMatchForUrl = (url, localization) => {
  const titleItems = getMedianNavigationTitleItems(localization);
  return getRegexMatchForUrl(url, titleItems) || null;
};

const resolveMedianNavigationTitlesLocalization = (localization) => {
  if (localization) {
    return normalizeAutomaticLocalization(localization);
  }

  return normalizeAutomaticLocalization(
    getMedianLocalizationFromHostname(window.location.hostname)
  );
};

const getMedianBackFriendlyNavigationTitle = (localization) => {
  const normalizedLocalization = normalizeAutomaticLocalization(localization);

  return (
    MEDIAN_BACK_FRIENDLY_NAVIGATION_TITLES[normalizedLocalization] ||
    MEDIAN_BACK_FRIENDLY_NAVIGATION_TITLES.fr
  );
};

const getMedianNavigationTitle = (localization, location = {}, options = {}) => {
  const resolvedLocalization = resolveMedianNavigationTitlesLocalization(localization);

  if (options.mode === 'back-friendly') {
    return getMedianBackFriendlyNavigationTitle(resolvedLocalization);
  }

  const resolvedLocation = resolveLocation(location);
  const currentUrl = buildLocationUrl(resolvedLocation);
  const matchedTitleRule = getMedianNavigationTitleMatchForUrl(currentUrl, resolvedLocalization);

  return matchedTitleRule ? matchedTitleRule.title : MEDIAN_DEFAULT_NAVIGATION_TITLE;
};

const getMedianTabLabels = (localization) => {
  const normalizedLocalization = normalizeAutomaticLocalization(localization);
  return MEDIAN_TAB_LABELS[normalizedLocalization] || MEDIAN_TAB_LABELS.fr;
};

const getMedianTabItems = (localization) => {
  const [searchLabel, listLabel, reservationsLabel, messagesLabel, accountLabel] =
    getMedianTabLabels(localization);
  const baseUrl = getMedianLocalizationLink(resolveLocalization(localization));

  return [
    {
      url: joinBaseAndPath(baseUrl, '/'),
      label: searchLabel,
      icon: 'fat fa-magnifying-glass',
      subLinks: [],
    },
    {
      url: joinBaseAndPath(baseUrl, '/listings'),
      label: listLabel,
      icon: 'fat fa-tags',
      subLinks: [],
      regex:
        '^https://[^/]+/(l/new$|l/[^/]+/[0-9a-fA-F-]{36}/(new|draft|edit)/.*|listings$|income$|your-availabilities$|calendar/.*|congratulation-after-ad-creation$)(?:[?#].*)?$',
    },
    {
      url: joinBaseAndPath(baseUrl, '/reservations/pending'),
      label: reservationsLabel,
      icon: 'fat fa-calendar',
      subLinks: [],
      regex:
        '^https://[^/]+/(reservations/.*|order/.*|sale/.*|cart$|cart/checkout$|l/[^/]+/[0-9a-fA-F-]{36}/checkout.*)(?:[?#].*)?$',
    },
    {
      url: joinBaseAndPath(baseUrl, '/messages'),
      label: messagesLabel,
      icon: 'fat fa-message',
      subLinks: [],
      regex: '^https://[^/]+/messages(/.*)?(?:[?#].*)?$',
    },
    {
      url: joinBaseAndPath(baseUrl, '/account-settings'),
      label: accountLabel,
      icon: 'fat fa-user',
      subLinks: [],
      regex:
        '^https://[^/]+/(account-settings.*|login$|signup$|recover-password$|reset-password$|verify-email$)(?:[?#].*)?$',
    },
  ];
};

const setMedianTabsForLocalization = async (localization) => {
  const Median = await waitForMedianBridgeReady();
  const resolvedLocalization = normalizeAutomaticLocalization(localization);
  const tabItems = getMedianTabItems(resolvedLocalization);

  if (!Median || !Median.tabNavigation || typeof Median.tabNavigation.setTabs !== 'function') {
    return false;
  }

  Median.tabNavigation.setTabs({ enabled: true, items: tabItems });

  return true;
};

export const setMedianNavigationTitlesForLocalization = async (
  localization,
  location = {},
  options = {}
) => {
  const Median = await waitForMedianBridgeReady();
  const setCurrent = Median?.navigationTitles?.setCurrent;

  if (typeof setCurrent !== 'function') {
    return false;
  }

  const titleToApply = getMedianNavigationTitle(localization, location, options);

  try {
    setCurrent({ title: titleToApply });
    return true;
  } catch (error) {
    try {
      setCurrent({ title: encodeURIComponent(titleToApply) });
      return true;
    } catch (fallbackError) {
      console.warn(
        '[medianBridge] Unable to set navigation title',
        serializeError(error),
        serializeError(fallbackError)
      );
      return false;
    }
  }
};

export const setMedianBackFriendlyNavigationTitle = async (localization, location = {}) => {
  return setMedianNavigationTitlesForLocalization(localization, location, {
    mode: 'back-friendly',
  });
};
